import { render, staticRenderFns } from "./PaymentRentCreateUpdate.vue?vue&type=template&id=4dbd97ca&"
import script from "./PaymentRentCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./PaymentRentCreateUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports